/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

export const EVENT_SEARCH = 'eventSearch';
export const SEARCH = 'search';
export const SEARCH_CATEGORY = 'site search';
export const RESULTS_LOADED = 'Results loaded';
export const NO_RESULTS_FOUND = 'No Results Found';
export const MY_WISHLIST = 'my-wishlist';
export const WISHLIST = 'wishlist';
export const GROUPED = 'grouped';
export const HOMEPAGE = 'homepage';
export const LOGIN = 'Logged in';
export const LOGOUT = 'Logged out';
export const NOT_APPLICABLE = 'N/A';
export const CATEGORY_PRODUCT_LIST = 'CategoryProductList';
export const PRODUCT_LIST_WIDGET = 'ProductListWidget';
export const CATEOGRY_LIMIT = 5;
export const NOT_FOUND = 'notFound';
export const CHECKOUT = 'checkout';
export const ZERO = 0;
export const ONE = 1;
export const ROOT = '/';

export const PAGE_TYPE_HOME = 'Home';
export const PAGE_TYPE_CATEGORY = 'Category';
export const PAGE_TYPE_PDP = 'Product';
export const PAGE_TYPE_CART = 'Cart';
export const PAGE_TYPE_CHECKOUT_SUCCESS = 'Purchase';
export const PAGE_TYPE_SEARCH = 'searchresults';
export const PAGE_TYPE_CHECKOUT = 'Cart';
